import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { getAuth, getUserType } from "./lib/auth";

// Pages
import LoginPage from "./pages/LoginPage";
import ChecklistPage from "./pages/driver/ChecklistPage";
import HistoryPage from "./pages/driver/HistoryPage";
import AdminDashboard from "./pages/admin/AdminDashboard";
import DriversPage from "./pages/admin/DriversPage";
import VehiclesPage from "./pages/admin/VehiclesPage";
import ChecksPage from "./pages/admin/ChecksPage";

// Protected Route Component
const ProtectedRoute = ({ children, allowedType }) => {
  const auth = getAuth();
  
  if (!auth) {
    return <Navigate to="/" replace />;
  }
  
  if (allowedType && auth.user.user_type !== allowedType) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

// Redirect authenticated users
const AuthRoute = ({ children }) => {
  const auth = getAuth();
  
  if (auth) {
    if (auth.user.user_type === 'admin') {
      return <Navigate to="/admin/dashboard" replace />;
    }
    return <Navigate to="/driver/checklist" replace />;
  }
  
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={
            <AuthRoute>
              <LoginPage />
            </AuthRoute>
          } />

          {/* Driver Routes */}
          <Route path="/driver/checklist" element={
            <ProtectedRoute allowedType="driver">
              <ChecklistPage />
            </ProtectedRoute>
          } />
          <Route path="/driver/history" element={
            <ProtectedRoute allowedType="driver">
              <HistoryPage />
            </ProtectedRoute>
          } />

          {/* Admin Routes */}
          <Route path="/admin/dashboard" element={
            <ProtectedRoute allowedType="admin">
              <AdminDashboard />
            </ProtectedRoute>
          } />
          <Route path="/admin/drivers" element={
            <ProtectedRoute allowedType="admin">
              <DriversPage />
            </ProtectedRoute>
          } />
          <Route path="/admin/vehicles" element={
            <ProtectedRoute allowedType="admin">
              <VehiclesPage />
            </ProtectedRoute>
          } />
          <Route path="/admin/checks" element={
            <ProtectedRoute allowedType="admin">
              <ChecksPage />
            </ProtectedRoute>
          } />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
